export class Alert {
  static alert = (title, description) => {
    // eslint-disable-next-line no-alert
    window.alert([title, description].join('\n\n'))
  }
}
